import React from 'react';
import circlesPng from '../../assets/circles.png';

type CirclesGlyphProps = {
  className?: string;
  size?: number; // optional pixel size override
};

export const CirclesGlyph: React.FC<CirclesGlyphProps> = ({ className, size }) => {
  const dimensionStyle = size ? { width: size, height: size } : undefined;
  return (
    <span
      className={className}
      style={{
        ...dimensionStyle,
        display: 'inline-block',
        backgroundColor: 'currentColor',
        WebkitMaskImage: `url(${circlesPng})`,
        maskImage: `url(${circlesPng})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
      }}
      aria-hidden="true"
    />
  );
};

export default CirclesGlyph;
